<template>
  <div class="box">
    <arrorImg bg="white"></arrorImg>
    <navBar title="书币福利" color="#ffffff"></navBar>
    <div class="content">
      <img src="../../../static/currency-bg.jpg" alt="" />
      <div class="content-pos">
        <p class="content-title">——微信VIP读者福利——</p>
        <p class="content-tips">书币赠礼享不停！</p>
        <div class="content-box">
          <p>
            {{
              receiveStatus
                ? "您已成为微信VIP读者！"
                : "恭喜您成为微信VIP读者！"
            }}
          </p>
          <div @click="goBook">
            马上去看书 <img src="../../../static/right-arrow.png" alt="" />
          </div>
          <p v-if="!receiveStatus">
            领取成功 <span>{{ currency }}</span
            >书币已到账
          </p>
          <p v-else>已领取，每人限领一次</p>
        </div>
        <div class="text-tips">
          <p>微信VIP读者福利:</p>
          <p>
            1.成功添加就送{{ currency }}书币奖励，人人有份;书币有效期{{
              validiTime
            }}天，请在有效期内使用完毕；
          </p>
          <p>2.提供最划算充值优惠，看书最便宜；</p>
          <p>3.1对1阅读管家优质服务，疑难问题优先解决；</p>
          <p>4.每月超多福利活动，您想要，我们就有！</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      isEntranceData: "",
      pageType: "",
      currency: 0,
      receiveStatus: true, //领取状态，true领取，false未领取
      validiTime: 0, //有效时间
      promotionCode:''
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    } 
    if (this.$route.query.promotionCode) {
      this.promotionCode = this.$route.query.promotionCode;
    }
    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.insertPageAccessData();
      this.getJumpUrlBookCurrency();
    } else {
      this.insertPageAccessData();
      this.getJumpUrlBookCurrency();
    }
  },
  methods: {
    insertPageAccessData() {
      var  pagename='';
      if(this.pageType=='bookCity'){
        pagename='书城'
      }else if(this.pageType=='bookCharge'){
        pagename='充值中心'
      }
      var params = {
        pageName: "微信VIP读者福利",
        pageRemark: "上级页面：" + pagename,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    goBook() {
      this.$base.setStorage("tabbarIndex", 0);
      this.$router.replace({ path: "/" });
    },
    getJumpUrlBookCurrency() {
      var params={
        promotionCode:this.promotionCode,
        automaticCollection:1
      }
      //领取书币接口
      this.$api.getJumpUrlBookCurrency(params).then((res) => {
        if (res.status == 1) {
          this.currency = res.data.currency;
          this.receiveStatus = res.data.receiveStatus;
          this.validiTime = res.data.effectTime;
        }
      });
    },
  },
};
</script>

<style scoped>
.box {
  min-height: 100%;
  background-color: #f3f3f3;
  overflow: hidden;
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.content {
  width: 100%;
  margin-top: calc(44px + env(safe-area-inset-top));
  box-sizing: border-box;
  position: relative;
}
.content > img {
  width: 100%;
  display: block;
}
.content-pos {
  position: absolute;
  top: 0px;
  left: 0px;
  padding:30px 16px;
}
.content-title {
  border: 1px solid #ffd382;
  border-radius: 100px;
  font-size: 14px;
  color: #ffd382;
  width: 205px;
  height: 27px;
  line-height: 27px;
  text-align: center;
  margin: 0 auto;
}
.content-tips {
  font-size: 40px;
  color: #ffd382;
  margin-top: 22px;
  margin-bottom: 30px;
  text-align: center;
}
.content-box {
  width: 100%;
  background-image: linear-gradient(-180deg, #33302c 0%, #232221 100%);
  border: 1px solid #ffe0a7;
  border-radius: 4px;
  padding: 20px 24px;
  box-sizing: border-box;
  text-align: center;
}
.content-box > p:nth-of-type(1) {
  font-size: 16px;
  color: #ffe0a7;
}
.content-box > div {
  background-image: linear-gradient(-180deg, #ffedae 0%, #ffd28b 100%);
  border-radius: 100px;
  font-size: 18px;
  color: #842a00;
  width: 280px;
  height: 50px;
  line-height: 50px;
  margin-top: 20px;
  margin-bottom: 14px;
  font-weight: bold;
}
.content-box > div img {
  width: 17px;
  height: 10px;
}
.content-box > p:nth-of-type(2) {
  font-size: 12px;
  color: #d5cdb6;
}
.content-box > p span {
  color: #ffe0a7;
  font-size: 13px;
}
.text-tips {
  font-size: 12px;
  color: #d5cdb6;
  line-height: 21px;
  margin-top: 50px;
}
.text-tips > p:nth-of-type(1) {
  font-size: 14px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/view/drawCurrency/index.vue